<template>
  <div class="photos-section">
    <div class="photos-grid">
      <div class="photos-item reveal">
        <MediaSlotImage
          slot-code="work.photo_1"
          :fallback="photos[0].src"
          :alt="photos[0].alt"
          sizes="(max-width: 767px) 100vw, 50vw"
          :width="1280"
          :height="960"
        />
      </div>
      <div class="photos-item reveal reveal-delay-1">
        <MediaSlotImage
          slot-code="work.photo_2"
          :fallback="photos[1].src"
          :alt="photos[1].alt"
          sizes="(max-width: 767px) 100vw, 50vw"
          :width="1280"
          :height="960"
        />
      </div>
      <div class="photos-item reveal reveal-delay-2">
        <MediaSlotImage
          slot-code="work.photo_3"
          :fallback="photos[2].src"
          :alt="photos[2].alt"
          sizes="(max-width: 767px) 100vw, 50vw"
          :width="1280"
          :height="960"
        />
      </div>
      <div class="photos-item reveal reveal-delay-1">
        <MediaSlotImage
          slot-code="work.photo_4"
          :fallback="photos[3].src"
          :alt="photos[3].alt"
          sizes="(max-width: 767px) 100vw, 50vw"
          :width="1280"
          :height="960"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { cdnUrl } from "~/utils/cdn";
import MediaSlotImage from "~/core/components/atoms/media-slot-image/media-slot-image.vue";

export default {
  name: "WorkWithUsPhotos",
  components: { MediaSlotImage },
  data() {
    return {
      photos: [
        {
          src: cdnUrl(
            "/image/HOOLIGANS+WEB/Photos+by+brands/PRADA/IMG_8927.JPG"
          ),
          alt: "Prada eyewear collection",
        },
        {
          src: cdnUrl(
            "/image/HOOLIGANS+WEB/Photos+by+brands/DIOR/3670+IMG_9945.jpg"
          ),
          alt: "Dior eyewear collection",
        },
        {
          src: cdnUrl("/image/HOOLIGANS+WEB/Work+With+Us/19.jpg"),
          alt: "Hooligans Eyewear lifestyle",
        },
        {
          src: cdnUrl("/image/HOOLIGANS+WEB/Work+With+Us/3707+IMG_2767.jpg"),
          alt: "Hooligans Eyewear collection",
        },
      ],
    };
  },
};
</script>
